/**
 * Resultados de una campaña por grupo de Activa (Dormidos, En riesgo…): enviados y tasas. Con un
 * solo grupo la tabla igual se muestra: dice a quién le llegó.
 */

import type { FilaGrupo } from "../../types.estadisticas";
import { NOTA_BASES_TASAS, tasaTexto } from "../../logic/estadisticas";
import { num } from "../../../campana-nueva/utils/format";

export function TablaPorGrupo({ filas, nombres = {} }: { filas: FilaGrupo[] | null | undefined; nombres?: Record<string, string> }) {
  if (!filas?.length) return <p className="text-sm text-slate-400">Sin datos por grupo.</p>;
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        {/* las tasas no van todas sobre lo mismo: se dice (antes no, y no cerraban con el embudo) */}
        <caption className="caption-bottom pt-2 text-left text-[11px] text-slate-400">{NOTA_BASES_TASAS}</caption>
        <thead>
          <tr className="text-left text-[11px] font-bold uppercase tracking-wider text-slate-400">
            <th scope="col" className="py-2 pr-3">Grupo</th>
            <th scope="col" className="py-2 pr-3 text-right">Enviados</th>
            <th scope="col" className="py-2 pr-3 text-right">Entrega</th>
            <th scope="col" className="py-2 pr-3 text-right">Lectura</th>
            <th scope="col" className="py-2 pr-3 text-right">Respuesta</th>
            <th scope="col" className="py-2 text-right">Bajas</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-slate-100">
          {filas.map((g) => (
            <tr key={g.grupoId}>
              <td className="py-2.5 pr-3 text-slate-800">{g.nombre || nombres[g.grupoId] || g.grupoId || "Sin grupo"}</td>
              <td className="py-2.5 pr-3 text-right tabular-nums text-slate-900">{num(g.enviados)}</td>
              <td className="py-2.5 pr-3 text-right tabular-nums text-slate-700">{g.enviados ? tasaTexto(g.tasas?.entrega) : "—"}</td>
              <td className="py-2.5 pr-3 text-right tabular-nums text-slate-700">{g.enviados ? tasaTexto(g.tasas?.lectura) : "—"}</td>
              <td className="py-2.5 pr-3 text-right tabular-nums text-slate-700">{g.enviados ? tasaTexto(g.tasas?.respuesta) : "—"}</td>
              <td className="py-2.5 text-right tabular-nums text-slate-700">{g.enviados ? tasaTexto(g.tasas?.bajas) : "—"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default TablaPorGrupo;
